module.exports = __webpack_public_path__ + "img/mb-firefox.4f13c241.svg";